import { QueryFunction, useQuery, UseQueryResult } from '@tanstack/react-query';
import { Article } from '@twiliointernal/e2-commons-shared-definitions';

import { constants } from './definitions';
import { SupportApi } from '@twiliointernal/e2-commons-shared-api';
import { logger } from '@twiliointernal/e2-commons-shared-libs';

const getArticleById: QueryFunction = async ({ queryKey }) => {
  const [, articleId] = queryKey as [string, string];
  const emptyArticle = {};

  if (!articleId) {
    return Promise.resolve(emptyArticle);
  }

  try {
    const { data } = await SupportApi.getArticleById(articleId);
    const article = data?.article ?? emptyArticle;

    return article;
  } catch (error) {
    logger.error(`${constants.LOG_PREFIX}::${error}`);
  }
};

const useFetchArticle = (articleId: string): UseQueryResult<Article> => {
  const queryKey = [constants.fetchArticleFnKey, articleId];
  const queryFn = getArticleById;

  return useQuery({
    queryKey,
    queryFn,
  });
};

export default useFetchArticle;
